<div class="container-horizontal" id="container" #container>
  <ng-container *ngFor="let noticia of noticias; trackBy: trackByNoticia; let i = $index">
    <article class="noticia-horizontal" id="{{ 'noticia-' + (noticia.idVideo | kebabCase) }}">
      <div class="image-container">
        <app-skeleton-image [src]="generateMiniSrc(noticia.urlGenerica)" [customClass]="'noticia-imagen'" [alt]="noticia.tituloVideo"></app-skeleton-image>
      </div>
      <div class="bottom-controls-horizontal">
        <div class="footer-left">
          <div class="footer-container">
            <div class="tags-horizontal">
              <ng-container *ngIf="noticia.nombre_tag">
                <a [routerLink]="['/tag', noticia.nombre_tag | kebabCase]">
                  <span class="tags_articulo tag" [ngStyle]="{ color: noticia?.text_color_tag, 'background-color': noticia?.color_tag || noticia?.color_fondo_etiqueta }">
                    {{ noticia.nombre_tag }}
                  </span>
                </a>
              </ng-container>
              <div class="rrss-horizontal">
                <div class="sidebar-icon" (click)="mostrarRRSS(i)">
                  <app-icon-share [isSelected]="rrssVisible[i]" [ngClass]="{ 'rrss-selected': rrssVisible[i] }"></app-icon-share>
                </div>
                <div class="rrss_hor" [style.display]="rrssVisible[i] ? 'flex' : 'none'">
                  <div class="sidebar-icon">
                    <a [href]="'https://www.facebook.com/sharer/sharer.php?u=' + constantesGlobales.siteDomain + '/noticias/' + noticia?.idVideo + '/' + (noticia?.tituloSeo | kebabCase)" target="_blank">
                      <app-icon-facebook></app-icon-facebook>
                    </a>
                  </div>
                  <div class="sidebar-icon">
                    <a [href]="'https://twitter.com/intent/tweet?text=' + noticia?.tituloSeo + ' - ' + constantesGlobales.siteDomain + '/noticias/' + noticia?.idVideo + '/' + (noticia?.tituloSeo | kebabCase)" data-size="large" target="_blank">
                      <app-icon-twitter></app-icon-twitter>
                    </a>
                  </div>
                  <div class="sidebar-icon">
                    <a [href]="'https://api.whatsapp.com/send?text=' + noticia?.tituloSeo + ' - ' + constantesGlobales.siteDomain + '/noticias/' + noticia?.idVideo + '/' + (noticia?.tituloSeo | kebabCase)" data-action="share/whatsapp/share" target="_blank">
                      <app-icon-whatsapp></app-icon-whatsapp>
                    </a>
                  </div>
                  <div class="sidebar-icon">
                    <a [href]="'https://www.linkedin.com/sharing/share-offsite/?url=' + constantesGlobales.siteDomain + '/noticias/' + noticia?.idVideo + '/' + (noticia?.tituloSeo | kebabCase)" target="_blank">
                      <app-icon-linkedin></app-icon-linkedin>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div class="header-article">
              <h2>
                {{ noticia.tituloVideo }}
              </h2>
            </div>
            <div class="bottom-acceder">
              <a [routerLink]="['/noticias', noticia?.idVideo, noticia?.tituloSeo | kebabCase]"> Leer más </a>
            </div>
          </div>
        </div>
      </div>
    </article>
  </ng-container>
</div>
